import { type CurrencyExchange } from "@finway-group/shared/lib/models"
import { type Reducer } from "redux"
import { CurrencyActionTypes, type CurrencyActions, type FetchCurrencyExchangeAction } from "../actions/currency/currencyTypes"

export interface CurrencyState {
    item?: CurrencyExchange
}

const initialState = {
    item: undefined,
}

const fetchCurrencyExchange = (state: CurrencyState, action: FetchCurrencyExchangeAction): CurrencyState => ({
    ...state,
    item: action.currencyExchange,
})

export const currencyReducer: Reducer<CurrencyState, CurrencyActions> = (state = initialState, action) => {
    switch (action.type) {
        case CurrencyActionTypes.FETCH_CURRENCY_EXCHANGE:
            return fetchCurrencyExchange(state, action)
        default:
            return state
    }
}
